module.exports = __webpack_public_path__ + "static/media/koc_logo.f8a8f7e9.png";